"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Guard = void 0;
const argumentNullError_1 = require("./argumentNullError");
/**
 * A guard for parameter checking.
 */
class Guard {
    /**
     * Throws an @see ArgumentNullError if a passed in value is null or empty.
     * @param value Value to check for null or emptieness.
     * @param name Name of the parameter that is being checked.
     */
    static throwIfNullOrEmpty(value, name) {
        if (!value) {
            throw new argumentNullError_1.ArgumentNullError(`Parameter ${name} is null or empty.`, name);
        }
    }
    /**
     * Throws an @see ArgumentNullError if a passed in number is null or negative.
     * @param value Value to check for null or negative.
     * @param name Name of the parameter that is being checked.
     */
    static throwIfNullOrNegative(value, name) {
        if (value <= 0) {
            throw new argumentNullError_1.ArgumentNullError(`Parameter ${name} is null or negative.`, name);
        }
    }
}
exports.Guard = Guard;
//# sourceMappingURL=guard.js.map